import { useRef } from 'react';

import { useAtom } from 'jotai';

import { cookieJar } from '@consumer-frontend/nc-api';
import { NcBaseOptimizelyProvider } from '@consumer-frontend/nc-utils';

import { accountIdAtom } from '../../store/atoms';

/**
  The Optimizely Provider for the Dashboard application.  Uses an accountId for Optimizely Features and Testing
 */
export const NcDashboardOptimizelyProvider = ({ children }: { children: React.ReactNode; }) => {
  const [accountId] = useAtom(accountIdAtom);

  return <NcBaseOptimizelyProvider accountId={accountId}>{children}</NcBaseOptimizelyProvider>;
};

/**
  The Optimizely Provider for the Apply application.  Uses an apply_uuid cookie for Optimizely Features and Testing
 */
export const NcApplyOptimizelyProvider = ({ children }: { children: React.ReactNode; }) => {
  const uuid = useRef(cookieJar.getApplyUuid() || cookieJar.setApplyUuid());

  return <NcBaseOptimizelyProvider accountId={uuid.current}>{children}</NcBaseOptimizelyProvider>;
};
